import React, { useContext, useEffect, useState } from 'react';
import SMLSelect from '../../../../shared/components/SMLSelect';
import { valueToOption } from '../../../../shared/components/FormData';
import { ReportFormContext } from './ReportForm';

const WeeksSelect = ({weeksChoices}) => {
  const {formData, handleSelectChange} = useContext(ReportFormContext);

  useEffect(() => {
    const lastSelectedWeek = localStorage.getItem('lastSelectedWeek');

    valueToOption(lastSelectedWeek, weeksChoices, (option) => {
      handleSelectChange('week', option);
    });
  }, [weeksChoices]);

  useEffect(() => {
    valueToOption(formData.week, weeksChoices, (option) => {
      handleSelectChange('week', weekOption);
    });
  }, [formData.week]);

  return (
    <div className="form-group">
      <SMLSelect
      name="week"
      options={weeksChoices}
      value={formData.week}
      onChange={option => handleSelectChange('week', option)}
      placeholder={'Select report week'}
      />
    </div>
  );
};

export default WeeksSelect;
